import { Button } from "antd";
import { FilterOutlined } from "@ant-design/icons";
import { ListHeaderControls, tagFilters } from "src/components/ListPage";

export interface FilterControlsProps {
  libraryFilter: string;
  setLibraryFilter: (filter: string) => void;
  displayFilterControls?: boolean;
}

//TODO update the filter and filter state to use the library filter.

export function FilterControls({
  libraryFilter,
  setLibraryFilter,
  displayFilterControls = false,
}: FilterControlsProps): JSX.Element {
  // Count active filters (terms with prefixes)
  const activeFiltersCount = libraryFilter
    .split(" ")
    .filter(
      (term) =>
        term.startsWith("tag:") ||
        term.startsWith("in:") ||
        term.startsWith("type:") ||
        term.startsWith("scope:") ||
        term.startsWith("status:") ||
        term.startsWith("bookmark:")
    ).length;

  return (
    <ListHeaderControls
      placeholder="Search the feed..."
      filter={libraryFilter}
      setFilter={setLibraryFilter}
    >
      {displayFilterControls && (
        <Button
          icon={<FilterOutlined />}
          style={{ border: "none" }}
          type={activeFiltersCount > 0 ? "primary" : "default"}
        >
          {activeFiltersCount > 0 && `(${activeFiltersCount})`}
        </Button>
      )}
    </ListHeaderControls>
  );
}
